import { EventType } from "../../../../common/enums";
import { ISelectFieldModel } from "../../../../common/components/forms/inputs/dropdown/models/selectFieldModel";

// Sentinel id used by the multi-select "All halls" option. Matches the
// selectAllOption pattern used elsewhere (e.g. group event wizard plan types).
export const ALL_HALLS_OPTION_ID = 0;

export interface IPlannerFiltersState {
  selectedInstructors: ISelectFieldModel[];
  selectedEventTypes: EventType[];
  showDeletedEvents: boolean;
  selectedHallIds: number[];
}

export interface IFilterTag {
  id: string;
  label: string;
  type: "instructor" | "eventType" | "hall";
  onRemove: () => void;
}

export const createDefaultFiltersState = (): IPlannerFiltersState => ({
  selectedInstructors: [],
  selectedEventTypes: [],
  showDeletedEvents: false,
  selectedHallIds: [ALL_HALLS_OPTION_ID],
});

export const isAllHallsSelected = (selectedHallIds: number[]): boolean =>
  !selectedHallIds ||
  selectedHallIds.length === 0 ||
  selectedHallIds.includes(ALL_HALLS_OPTION_ID);